/* eslint-disable no-unused-vars */
import { Scene, Input, Math } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, randomDirection, directionHandler, setLastMovement, lightstickHandler } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import HealthBar from "../../phaser/components/healthBar";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import { addButtonMove } from "../../phaser/components/buttonMove";
import SettingsButton from "../../phaser/components/settingsButton";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;

let characterSelected;
let objNames = {};
let footsteps;
let gameSettings;
let defaultSettings = 1;

const randomPointsEnemy = [
    { x: 537, y: 405 },
    // { x: 940, y: 286 },
    { x: 2820, y: 858 },
    { x: 1302, y: 1980 },
    // { x: 2477, y: 413 }
    { x: 7431, y: 1239 }
    // { x: 8070, y: 1093 }
];

const positionBrokenMask = [
    { x: 69, y: 253 },
    // { x: 1179, y: 365 },
    { x: 3537, y: 1095 },
    { x: 1187, y: 2335 },
    { x: 7716, y: 1179 }
    // { x: 2572, y: 393 }
];

let instructionsHandler = 0;
let hasLightstick = false;
let lastCoordenates = null;
export default class Game8 extends Scene {

    constructor() {
        super({ key: "Game8" });
    }
    init(data) {
        // this.scene.restart();
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;
        objNames = {};
        this.enemy = null;
        this.startAll = false;
        this.liveEnemy = 100;
        instructionsHandler = 0;
        this.piecesMask = 0;
        this.events.off('buttonNext-dialogModal');
        this.randomRoom = null;
        this.randomRoomsEnemy = [];
        this.countRedRoom = 0;
        this.countRoom4 = 0;
        this.loadRoomsBesideRoom1 = true;
        this.loadRoomsBesideRoom2 = true;
        this.countToExit = 0;
        hasLightstick = false;
        setLastMovement('down');
        this.firstTime = true;
        this.countStartKill = 0;
    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            switch (data.id) {
                case 'instructions-start':
                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.close();
                            this.startAll = true;
                            instructionsHandler = 0;
                            this.showingInstruction = false;
                            if(this.isMobile) {
                                this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game8`, 300);
                                this.joystickManager.createJoystick();
                                this.joystickManager.activate(hasLightstick);
        
                            }
                            break;
                    }
                    break;
                case 'detonant-prestart':
                    switch (instructionsHandler) {
                        case 1:
                            this.firstTime = false;
                            this.dialogModal.close();
                            instructionsHandler = 0;
                            this.showingInstruction = false;
                            break;
                    }
                    break;
                case 'enemy-start':
                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.close();
                            instructionsHandler = 0;
                            this.showEnemy = true;
                            this.startAll = true;
                            this.randomRoom = 2;
                            this.randomRoomsEnemy.push(this.randomRoom);
                            this.waitingOver = true;
                            this.showingInstruction = false;
                            break;
                    }
                    break;
                case 'message-fullMask':
                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.close();
                            instructionsHandler = 0;
                            this.startAll = true;
                            objNames[characterSelected].active = true;
                            this.fullMask.setActive(true).setVisible(true);
                            this.showingInstruction = false;
                            break;
                    }
                    break;
                case 'message-get-mask':
                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.close();
                            instructionsHandler = 0;
                            this.startAll = true;
                            objNames[characterSelected].active = true;
                            this.door.setActive(true).setVisible(true);
                            this.showingInstruction = false;
                            break;
                    }
                    break;
                case 'enemy-kill':
                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.close();
                            instructionsHandler = 0;
                            objNames[characterSelected].active = true;
                            switch (this.randomRoom) {
                                case 0:
                                    this.brokenMask1.setPosition(positionBrokenMask[this.randomRoom].x, positionBrokenMask[this.randomRoom].y).setVisible(true);
                                    break;
                                case 1:
                                    this.brokenMask2.setPosition(positionBrokenMask[this.randomRoom].x, positionBrokenMask[this.randomRoom].y).setVisible(true);
                                    break;
                                case 2:
                                    this.brokenMask3.setPosition(positionBrokenMask[this.randomRoom].x, positionBrokenMask[this.randomRoom].y).setVisible(true);
                                    break;
                                case 3:
                                    this.brokenMask4.setPosition(positionBrokenMask[this.randomRoom].x, positionBrokenMask[this.randomRoom].y).setVisible(true);
                                    break;
                            }
                            this.showingInstruction = false;
                            this.startAll = true;

                            break;
                    }
                    break;
                case 'message-to-exit':
                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.close();
                            instructionsHandler = 0;
                            // this.startAll = true;
                            // objNames[characterSelected].active = true;
                            // lightstickHandler(objNames[characterSelected], `${characterSelected}-game8`);
                            setTimeout(() => {
                                let total = JSON.parse(localStorage.getItem('noL'));
                                if (total) {
                                    if (!total.includes(8)) {
                                        total.push(8);
                                        localStorage.setItem('noL', JSON.stringify(total));

                                    }
                                } else {
                                    localStorage.setItem('noL', JSON.stringify([8]));
                                }
                                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                                    if (progress === 1) {
                                        this.ppalSong.stop();
                                        this.scene.stop();
                                        this.events.off('buttonNext-dialogModal');

                                        this.scene.start(`Win`, { characterSelected: characterSelected, level: 8, lastCoordenates });
                                    }
                                });
                            }, 3000);
                            // this.exit.setActive(true).setVisible(true);
                            break;
                    }
                    break;

            }
        });

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                if (args.goHome) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true, lastCoordenates });
                }

                if (args.goStart) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.cameras.main.setBounds(0, 0, 11256);
        this.physics.world.setBounds(0, 0, 11256);

        this.ppalSong = this.sound.add(`screamSong`, { loop: true, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }

        this.map = mapHandler(this, 'game8', false, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2 });

        this.playing = false;
        walls = this.map.walls;
        walls.setScale(3);
        this.map.ground.setScale(3);



        this.room1 = this.map.map.createLayer('Room1', this.map.tileset, 0, 0);
        this.room1.setCollisionByProperty({ collides: true });
        this.room1.setScale(3);

        this.redRoom = this.map.map.createLayer('RedRoom', this.map.tileset, 0, 0);
        this.redRoom.setCollisionByProperty({ collides: true });
        this.redRoom.setScale(3);

        this.room2 = this.map.map.createLayer('Room2', this.map.tileset, 0, 0);
        this.room2.setCollisionByProperty({ collides: true });
        this.room2.setScale(3);

        this.room3 = this.map.map.createLayer('Room3', this.map.tileset, 0, 0);
        this.room3.setCollisionByProperty({ collides: true });
        this.room3.setScale(3);

        this.room4 = this.map.map.createLayer('Room4', this.map.tileset, 0, 0);
        this.room4.setCollisionByProperty({ collides: true });
        this.room4.setScale(3);
        
        this.room5 = this.map.map.createLayer('Room5', this.map.tileset, 0, 0);
        this.room5.setCollisionByProperty({ collides: true });
        this.room5.setScale(3);

        this.room2Limit = this.map.map.createLayer('LimitRoom1', this.map.tileset, 0, 0);
        this.room2Limit.setCollisionByProperty({ collides: true });
        this.room2Limit.setScale(3);

        this.room1Limit = this.map.map.createLayer('LimitRoom4', this.map.tileset, 0, 0);
        this.room1Limit.setCollisionByProperty({ collides: true });
        this.room1Limit.setScale(3);

        this.room3Limit = this.map.map.createLayer('LimitRoom5', this.map.tileset, 0, 0);
        this.room3Limit.setCollisionByProperty({ collides: true });
        this.room3Limit.setScale(3);
        
        this.doorRoom3Limit = this.map.map.createLayer('DoorLimitRoom5', this.map.tileset, 0, 0);
        this.doorRoom3Limit.setCollisionByProperty({ collides: true });
        this.doorRoom3Limit.setScale(3);

        this.room4Limit = this.map.map.createLayer('LimitRoom2', this.map.tileset, 0, 0);
        this.room4Limit.setCollisionByProperty({ collides: true });
        this.room4Limit.setScale(3);

        this.object = this.map.map.createLayer('Objects', this.map.tileset, 0, 0);
        this.object.setCollisionByProperty({ collides: true });
        this.object.setScale(3);

        this.door = this.map.map.createLayer('Door', this.map.tileset, 0, 0);
        this.door.setCollisionByProperty({ collides: true });
        this.door.setScale(3);
        this.door.setActive(false);

        this.exit = this.map.map.createLayer('Exit', this.map.tileset, 0, 0);
        this.exit.setCollisionByProperty({ collides: true });
        this.exit.setScale(3);
        this.exit.setActive(false);

        this.detonant = this.map.map.createLayer('Detonant', this.map.tileset, 0, 0);
        this.detonant.setCollisionByProperty({ collides: true });
        this.detonant.setScale(3);


        objNames[characterSelected] = this.physics.add.sprite(1302, 1980, `${characterSelected}-game8`, 4);
        objNames[characterSelected].setScale(2);
        objNames[characterSelected].setImmovable();
        walkAnimation(this, `${characterSelected}-game8`);
        reposeAnimation(this, `${characterSelected}-game8`);
        turnStaticAnimation(this, `${characterSelected}-game8`);
        upStaticAnimation(this, `${characterSelected}-game8`);
        leftStaticAnimation(this, `${characterSelected}-game8`);
        rightStaticAnimation(this, `${characterSelected}-game8`);
        backStaticAnimation(this, `${characterSelected}-game8`);
        lightstickAnimation(this, `${characterSelected}-game8`);

        objNames[characterSelected].anims.play(`repose-${characterSelected}-game8`);


        this.enemy = this.physics.add.sprite(0, 0, `enemy-game8`, 4).setActive(false).setVisible(false);
        this.enemy.setScale(2);
        this.enemy.setImmovable();

        walkAnimation(this, `enemy-game8`);
        reposeAnimation(this, `enemy-game8`);
        turnStaticAnimation(this, `enemy-game8`);
        upStaticAnimation(this, `enemy-game8`);
        leftStaticAnimation(this, `enemy-game8`);
        rightStaticAnimation(this, `enemy-game8`);
        backStaticAnimation(this, `enemy-game8`);
        lightstickAnimation(this, `enemy-game8`);

        this.brokenMask1 = this.physics.add.sprite(0, 0, 'brokenMask1').setVisible(false).setScale(3);
        this.brokenMask2 = this.physics.add.sprite(0, 0, 'brokenMask2').setVisible(false).setScale(3);
        this.brokenMask3 = this.physics.add.sprite(0, 0, 'brokenMask3').setVisible(false).setScale(3);
        this.brokenMask4 = this.physics.add.sprite(0, 0, 'brokenMask4').setVisible(false).setScale(3);
        this.fullMask = this.physics.add.sprite(5442, 780, 'fullMask').setVisible(false).setActive(false).setScale(3);

        this.lightstick = this.physics.add.sprite(0, 0, 'lightstick').setVisible(false).setActive(false).setScale(2);

        this.physics.add.collider(objNames[characterSelected], walls);
        this.physics.add.collider(objNames[characterSelected], this.object);
        this.physics.add.collider(this.enemy, this.object, () => {
            randomDirection('enemy-game8');
        }, null, this);
        this.physics.add.collider(this.enemy, this.room1Limit, () => {
            randomDirection('enemy-game8');
        }, null, this);
        this.physics.add.collider(this.enemy, this.room2Limit, () => {
            randomDirection('enemy-game8');
        }, null, this);
        this.physics.add.collider(this.enemy, this.room3Limit, () => {
            randomDirection('enemy-game8');
        }, null, this);
        this.physics.add.collider(this.enemy, this.room4Limit, () => {
            randomDirection('enemy-game8');
        }, null, this);

        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.deadSprite = this.physics.add.sprite(1622, 2051, `humo-game8`).setScale(2.5).setVisible(false);
        this.anims.create({
            key: `deadSpriteAnimation`,
            frames: this.anims.generateFrameNumbers('humo-game8', { start: 0, end: 16 }),
            frameRate: 7,
            repeat: -1
        });

        this.physics.add.overlap(objNames[characterSelected], this.room1, function onOverlap() {
            // if (!this.hasZoom) {
                // this.updateRoomOverlapNoZoom(() => {
                    this.loadRoomsBesideRoom1 = false;
                    if (this.waitingOver && this.randomRoom === 1) {
                        this.waitingOver = false;
                        setTimeout(() => {
                            this.colliderSection = this.physics.add.collider(objNames[characterSelected], this.room2Limit);
                        }, 100);
                        this.enemy.setPosition(randomPointsEnemy[this.randomRoom].x, randomPointsEnemy[this.randomRoom].y).setActive(true).setVisible(true);
                        this.hp = new HealthBar(this, (this.enemy.x / 3) - 290, (this.enemy.y / 3) - 245);
                        // this.hp = new HealthBar(this, (this.enemy.x / 3) - 45, (this.enemy.y / 3) - 50);

                        this.hp.setVisible(true);
                    }

                // })
            // }

        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.room4, function onOverlap() {

            if (this.hasZoom) {
                this.updateRoomOverlapZoom(() => {
                    
                });
            }

        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );
        
        this.physics.add.overlap(objNames[characterSelected], this.room5, function onOverlap() {

            this.loadRoomsBesideRoom2 = true;

            if (this.waitingOver && this.randomRoom === 2) {
                this.waitingOver = false;
                this.colliderSection = this.physics.add.collider(objNames[characterSelected], this.room3Limit)
                
                //TODO MOSTRAR MENSAJE LIMITE
                this.colliderSectionDoor = this.physics.add.collider(objNames[characterSelected], this.doorRoom3Limit, () => {
                    this.limitMessage.setPosition(this.screenCenterX + 200, this.screenCenterY);
                    this.limitMessage.visible = true;

                    setTimeout(() => {
                        this.limitMessage.visible = false;
                    }, 1000);
                    // this.dialogModal._createImageDialog(this, 'detonant-prestart');
                    // // TODO METER AL LIMTE DEL CUARTO
                    // this.dialogModal.setText("I don't think I can leave this room without touching that strange purple object.".toUpperCase(), `${characterSelected}-hallway`, false, false)
                });

                this.enemy.setPosition(randomPointsEnemy[this.randomRoom].x, randomPointsEnemy[this.randomRoom].y).setActive(true).setVisible(true);
                this.hp = new HealthBar(this, this.enemy.x - 40, this.enemy.y - 65);
                this.hp.setVisible(true);
            }

        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.room2, function onOverlap() {
            // if (!this.hasZoom) {
            //     this.updateRoomOverlapNoZoom(() => {
                    this.loadRoomsBesideRoom2 = false;

                    if (this.waitingOver && this.randomRoom === 3) {
                        // setTimeout(() => {
                        // }, 1000);
                        this.colliderSection = this.physics.add.collider(objNames[characterSelected], this.room4Limit);
                        this.waitingOver = false;
                        this.enemy.setPosition(randomPointsEnemy[this.randomRoom].x, randomPointsEnemy[this.randomRoom].y).setActive(true).setVisible(true);
                        // this.hp = new HealthBar(this, this.enemy.x - 45, this.enemy.y - 50);
                        this.hp = new HealthBar(this, (this.enemy.x / 3) - 45, (this.enemy.y / 3) - 50);

                        this.hp.setVisible(true);
                    }

            //     })
            // }

        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.room3, function onOverlap() {
            if (!this.hasZoom) {
                this.updateRoomOverlapNoZoom()
            }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.detonant,
            function onOverlap() {
                if (this.detonant.active) {
                    this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                    this.instructionMessage.visible = true;

                    if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                        clearTimeout(this.timeout1);
                        this.timeout1 = setTimeout(() => {
                            this.startAll = false;
                            this.showingInstruction = true;
                            objNames[characterSelected].anims.play(`repose-${characterSelected}-game8`);
                            // this.dialogModal._createWindow(this, 'enemy-start', null, true);
                            this.dialogModal._createImageDialog(this, 'enemy-start');

                            this.dialogModal.setText("I just wanna make you scream. \nIf you want to leave this place, \nyou'll have to remove the masks from all of us.".toUpperCase(), `enemy-game8`, false, false)
                            this.detonant.active = false;
                        }, 1000)
                        // clearTimeout(this.timeoutDialog);
                        // this.timeoutDialog = setTimeout(() => {
                        //                         }, 1000);
                    }

                    clearTimeout(this.timeoutMonito);

                    // if(this.firstTime) {
                    //     this.dialogModal._createImageDialog(this, 'detonant-prestart');
                    // TODO METER AL LIMTE DEL CUARTO
                    //     this.dialogModal.setText("I don't think I can leave this room without touching that strange purple object.".toUpperCase(), `${characterSelected}-hallway`, false, false)
                    // }

                    // this.detonant.active = false;

                    this.timeoutMonito = setTimeout(() => {
                        this.instructionMessage.visible = false;
                    }, 1000);
                }

            }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.enemy,
            function onOverlap() {
                if (this.enemy.active) {
                    this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                     this.instructionMessage.visible = true;
                    if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                        this.deadSprite.visible = true;
                        this.deadSprite.anims.play(`deadSpriteAnimation`, true);
                        if (this.hp && this.hp.decrease(1)) {
                            this.countStartKill++;
                            this.enemy.active = false;
                            this.enemy.visible = false;
                            this.hp.setVisible(false);
                            // this.hp = null;
                            this.deadSprite.visible = false;
                            objNames[characterSelected].active = false;
                            objNames[characterSelected].setVelocity(0, 0);
                            objNames[characterSelected].setFrame(4);
                            objNames[characterSelected].anims.play(`repose-${characterSelected}-game8`);

                            this.showingInstruction = true;
                            this.startAll = false;

                            // this.dialogModal._createWindow(this, 'enemy-kill', null, true);
                            this.dialogModal._createImageDialog(this, 'enemy-kill');

                            let messageDialog = '';

                            switch(this.countStartKill) {
                                case 1:
                                    messageDialog = "It wasn't difficult, but she threw a fragment of the mask far away. \nI need to pick it up before moving forward";
                                    break;
                                case 2:
                                    messageDialog = "Second enemy defeated, \nnow I need to search for the fragment of the mask she had";
                                    break;
                                case 3:
                                    messageDialog = "How many enemies are left? \nAt least I've obtained one more fragment";
                                    break;
                                case 4:
                                    messageDialog = "I think she was the last one. \nI need to find the fragment of the mask she had";
                                    break;
                            }

                            this.dialogModal.setText(messageDialog.toUpperCase(), `${characterSelected}-hallway`, false, false);

                        }

                        setTimeout(() => {
                            this.deadSprite.visible = false;
                            this.instructionMessage.visible = false;
                        }, 1000);

                    }

                }

            }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );


        this.physics.add.overlap(objNames[characterSelected], this.brokenMask1, function onOverlap() {
            if (this.brokenMask1.active) {
                this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                this.instructionMessage.visible = true;

                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    this.brokenMask1.visible = false;
                    this.instructionMessage.visible = false;

                    this.brokenMask1.active = false;
                    this.colliderSection.active = false;
                    this.piecesMask++;
                    // clearTimeout(this.timeoutDialog);
                    // this.timeoutDialog = setTimeout(() => {

                    if (this.piecesMask < 4) {
                        // const lastRandomRoom = this.randomRoom;
                        // while(lastRandomRoom === this.randomRoom) {
                        //     this.randomRoom = Math.Between(0, 3);
                        // }
                        do {
                            this.randomRoom = Math.Between(0, 3);
                        } while (this.randomRoomsEnemy.includes(this.randomRoom));
                        this.randomRoomsEnemy.push(this.randomRoom);
                        this.waitingOver = true;
                        // this.enemy.setPosition(randomPointsEnemy[this.randomRoom].x, randomPointsEnemy[this.randomRoom].y).setActive(true).setVisible(true);
                        // this.hp = new HealthBar(this, this.enemy.x, this.enemy.y);

                    } else {
                        this.createDialogFullMask();
                    }
                    // }, 1000);
                }

                clearTimeout(this.timeoutMonito);

                this.timeoutMonito = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 1000);

            }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.brokenMask2, function onOverlap() {
            if (this.brokenMask2.active) {
                this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                this.instructionMessage.visible = true;

                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    this.brokenMask2.visible = false;
                    this.instructionMessage.visible = false;

                    this.brokenMask2.active = false;
                    this.physics.world.removeCollider(this.colliderSection);
                    // clearTimeout(this.timeoutDialog);
                    // this.timeoutDialog = setTimeout(() => {
                    this.piecesMask++;

                    if (this.piecesMask < 4) {
                        // const lastRandomRoom = this.randomRoom;
                        // while(lastRandomRoom === this.randomRoom) {
                        //     this.randomRoom = Math.Between(0, 3);
                        // }
                        do {
                            this.randomRoom = Math.Between(0, 3);
                        } while (this.randomRoomsEnemy.includes(this.randomRoom));
                        this.randomRoomsEnemy.push(this.randomRoom);
                        this.waitingOver = true;
                        // this.enemy.setPosition(randomPointsEnemy[this.randomRoom].x, randomPointsEnemy[this.randomRoom].y).setActive(true).setVisible(true);
                        // this.hp = new HealthBar(this, this.enemy.x, this.enemy.y);

                    } else {
                        this.createDialogFullMask();
                    }
                    // }, 1000);
                }
                clearTimeout(this.timeoutMonito);

                this.timeoutMonito = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 1000);
            }

        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.brokenMask3, function onOverlap() {
            if (this.brokenMask3.active) {
                this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                this.instructionMessage.visible = true;

                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    this.brokenMask3.visible = false;
                    this.instructionMessage.visible = false;
                    this.doorRoom3Limit.active = false;
                    this.doorRoom3Limit.visible = false;

                    this.brokenMask3.active = false;
                    this.physics.world.removeCollider(this.colliderSection);
                    this.physics.world.removeCollider(this.colliderSectionDoor);
                    // clearTimeout(this.timeoutDialog);
                    // this.timeoutDialog = setTimeout(() => {
                    this.piecesMask++;

                    if (this.piecesMask < 4) {
                        // const lastRandomRoom = this.randomRoom;
                        // while(lastRandomRoom === this.randomRoom) {
                        //     this.randomRoom = Math.Between(0, 3);
                        // }
                        do {
                            this.randomRoom = Math.Between(0, 3);
                        } while (this.randomRoomsEnemy.includes(this.randomRoom));
                        this.randomRoomsEnemy.push(this.randomRoom);
                        this.waitingOver = true;
                        // this.enemy.setPosition(randomPointsEnemy[this.randomRoom].x, randomPointsEnemy[this.randomRoom].y).setActive(true).setVisible(true);
                        // this.hp = new HealthBar(this, this.enemy.x, this.enemy.y);

                    } else {
                        this.createDialogFullMask();
                    }
                    // }, 1000);
                }

                clearTimeout(this.timeoutMonito);

                this.timeoutMonito = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 1000);

            }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.brokenMask4, function onOverlap() {
            if (this.brokenMask4.visible) {
                this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                this.instructionMessage.visible = true;

                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    this.brokenMask4.visible = false;
                    this.brokenMask4.active = false;
                    this.instructionMessage.visible = false;

                    this.physics.world.removeCollider(this.colliderSection);
                    // clearTimeout(this.timeoutDialog);
                    // this.timeoutDialog = setTimeout(() => {
                    this.piecesMask++;

                    if (this.piecesMask < 4) {
                        // const lastRandomRoom = this.randomRoom;
                        // while(lastRandomRoom === this.randomRoom) {
                        //     this.randomRoom = Math.Between(0, 3);
                        // }
                        do {
                            this.randomRoom = Math.Between(0, 3);
                        } while (this.randomRoomsEnemy.includes(this.randomRoom));
                        this.randomRoomsEnemy.push(this.randomRoom);
                        this.waitingOver = true;
                        // this.enemy.setPosition(randomPointsEnemy[this.randomRoom].x, randomPointsEnemy[this.randomRoom].y).setActive(true).setVisible(true);
                        // this.hp = new HealthBar(this, this.enemy.x, this.enemy.y);

                    } else {
                        this.createDialogFullMask();
                    }
                    // }, 1000);
                }

                clearTimeout(this.timeoutMonito);

                this.timeoutMonito = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 1000);

            }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.redRoom, function onOverlap() {

            // if (this.hasZoom) {
            //     this.updateRoomOverlapZoom(() => {
            //         this.loadRoomsBesideRoom1 = true;
            //         objNames[characterSelected].setTint(0x6a2f28);
            //         this.brokenMask1.setTint(0x6a2f28);

            //         if (this.waitingOver && this.randomRoom === 0) {
            //             this.waitingOver = false;
            //             this.colliderSection = this.physics.add.collider(objNames[characterSelected], this.room1Limit);
            //             // if(this.brokenMask1.active) {
            //             // }

            //             // setTimeout(() => {
            //             // }, 1000);
            //             this.enemy.setPosition(randomPointsEnemy[this.randomRoom].x, randomPointsEnemy[this.randomRoom].y).setActive(true).setVisible(true);
            //             this.hp = new HealthBar(this, this.enemy.x - 290, this.enemy.y - 235);
            //             this.hp.setVisible(true);
            //         }

            //         clearTimeout(this.timeoutRedRoom);
            //         this.timeoutRedRoom = setTimeout(() => {
            //             objNames[characterSelected].clearTint();
            //             // this.countRedRoom = 0;
            //             // this.physics.world.removeCollider(this.colliderSection);

            //         }, 100);
            //     });
            // } else {
                objNames[characterSelected].setTint(0x6a2f28);
                this.brokenMask1.setTint(0x6a2f28);

                if (this.waitingOver && this.randomRoom === 0) {
                    this.waitingOver = false;
                    // if(this.brokenMask1.active) {
                        // }
                        
                    setTimeout(() => {
                        this.colliderSection = this.physics.add.collider(objNames[characterSelected], this.room1Limit);
                    }, 1000);
                    this.enemy.setPosition(randomPointsEnemy[this.randomRoom].x, randomPointsEnemy[this.randomRoom].y).setActive(true).setVisible(true);
                    this.hp = new HealthBar(this, this.enemy.x - 290, this.enemy.y - 235);
                    this.hp.setVisible(true);
                }

                clearTimeout(this.timeoutRedRoom);
                this.timeoutRedRoom = setTimeout(() => {
                    objNames[characterSelected].clearTint();
                    // this.countRedRoom = 0;
                    // this.physics.world.removeCollider(this.colliderSection);

                }, 100);
            // }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(this.enemy, this.redRoom, function onOverlap() {

            if (this.enemy.active) {
                // if(this.showEnemy) {
                // objNames[characterSelected].alpha = 0.5;
                this.enemy.setTint(0x6a2f28);
                this.deadSprite.setTint(0x6a2f28);
                if (this.hp) {
                    this.hp.setOpacity(0.2)
                }

                clearTimeout(this.timeoutRedRoom1);
                this.timeoutRedRoom1 = setTimeout(() => {
                    this.enemy.clearTint();
                    this.deadSprite.clearTint();
                    if (this.hp) {
                        this.hp.setOpacity(1)
                    }
                }, 100);

            }

            // }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );


        this.physics.add.overlap(objNames[characterSelected], this.fullMask, function onOverlap() {

            if (this.fullMask.active) {
                this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                this.instructionMessage.visible = true;

                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {

                    this.showingInstruction = true;
                    this.fullMask.visible = false;
                    this.fullMask.active = false;
                    objNames[characterSelected].active = false;
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].setFrame(4);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game8`);
                    this.startAll = false;
                    // this.dialogModal._createWindow(this, 'message-get-mask', null, true);
                    this.dialogModal._createImageDialog(this, 'message-get-mask');

                    this.dialogModal.setText("Oh, I found a note that says 'Devil eyes come'. \nWhat could it mean? \nI think I must investigate the large tree I saw.".toUpperCase(), `${characterSelected}-hallway`, false, false)
                }

                clearTimeout(this.timeoutMonito);

                this.timeoutMonito = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 1000);

            }

            // }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        //TODO PONER ZOOM
        this.physics.add.overlap(objNames[characterSelected], this.door, function onOverlap() {

            if (this.door.active) {
                this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                this.instructionMessage.visible = true;

                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    this.instructionMessage.visible = false;
                    if (!this.hasZoom) {
                        this.updateRoomOverlapNoZoom(() => {
                    // this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    //     if (progress === 1) {
                            // hasLightstick = true;
                            objNames[characterSelected].setPosition(3400, 800);
                            // objNames[characterSelected].active = false;
                            setLastMovement('down');
                            this.cameras.main.fadeIn();
                            this.lightstick.setPosition(3200, 800).setActive(true).setVisible(true);
                            // lightstickHandler(objNames[characterSelected], `${characterSelected}-game8`);
                            // this.dialogModal._createWindow(this, 'message-to-exit', null, true);
                            // this.dialogModal.setText("mensaje para salir".toUpperCase(), true, true)
                                });
                            }
                    //     }
                    // });
                }

                clearTimeout(this.timeoutMonito);

                this.timeoutMonito = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 1000);

            }

            // }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.lightstick, function onOverlap() {

            if (this.lightstick.active) {
                this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                this.instructionMessage.visible = true;

                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    this.instructionMessage.visible = false;
                    this.startAll = false;
                    hasLightstick = true;
                    if(this.isMobile) {
                        this.joystickManager.setLightStickValue(hasLightstick);
                    }
                    this.lightstick.active = false;
                    this.lightstick.visible = false;

                    this.showingInstruction = true;
                    // this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    //     if (progress === 1) {
                    // hasLightstick = true;
                    // objNames[characterSelected].setPosition(3400, 800);
                    // objNames[characterSelected].active = false;
                    // setLastMovement('down');
                    // this.cameras.main.fadeIn();
                    // this.lightstick.setPosition(3200, 800).setActive(true).setVisible(true);
                    lightstickHandler(objNames[characterSelected], `${characterSelected}-game8`);
                    // objNames[characterSelected].anims.play(`repose-${characterSelected}-game8`);
                    // this.dialogModal._createWindow(this, 'message-to-exit', null, true);
                    this.dialogModal._createImageDialog(this, 'message-to-exit');

                    this.dialogModal.setText("At last, I found my lightstick. \nIt's been here all this time.".toUpperCase(), `${characterSelected}-hallway`, false, false)
                }
                // });
                clearTimeout(this.timeoutMonito);

                this.timeoutMonito = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 1000);
            }

            // if (this.exit.active) {
            //     this.countToExit++;

            //     if (this.countToExit === 40) {
            //         let total = JSON.parse(localStorage.getItem('noL'));
            //         if (total) {
            //             if (!total.includes(8)) {
            //                 total.push(8);
            //                 localStorage.setItem('noL', JSON.stringify(total));

            //             }
            //         } else {
            //             localStorage.setItem('noL', JSON.stringify([8]));
            //         }
            //         this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
            //             if (progress === 1) {
            //                 this.ppalSong.stop();
            //                 this.scene.stop();
            //                 this.events.off('buttonNext-dialogModal');

            //                 this.scene.start(`Win`, { characterSelected: characterSelected, level: 8 });
            //             }
            //         });

            //     }

            // }

            // }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);


        window.addEventListener("blur", () => {
            this.buttonPause.pauseByEvent();
        });

        // document.addEventListener('visibilitychange', () => {
        //     if (document.visibilityState !== 'visible') {
        //         this.buttonPause.pauseByEvent();
        //     }
        // });

        // this.dialogModal._createWindow(this, 'instructions-start', null, true);
        this.dialogModal._createImageDialog(this, 'instructions-start');
        this.showingInstruction = true;
        this.dialogModal.setText("This strange purple thing... \nIts energy is captivating. \nWhat will happen if I touch it?".toUpperCase(), `${characterSelected}-hallway`, false, false)
        // this.instructionMessage = this.add.text((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 45, 16, 'INTERACT: SPACEBAR', { font: "30px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 3 }).setVisible(false).setOrigin(1, 0).setScrollFactor(0);
        this.instructionMessage = this.add.bitmapText(0, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);        
        this.limitMessage= this.add.bitmapText(0, 20, 
            'pixelfont', "I don't think I can leave the rooms without the mask fragment".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);

        if (this.isMobile) {
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        this.lightstickCounter = new LightstickCounter(this);

        const x = 40;
        const y = 16;

        this.add.image(x, y, `brokenMask1`, 0).setScale(2).setOrigin(1, 0).setScrollFactor(0).setAngle(30);
        this.textMask = this.add.bitmapText(x + 55, y + 5, 'pixelfont',`${this.piecesMask}/4`.toUpperCase(), 10, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(1, 0).setScrollFactor(0).setScale(1.5)

        this.screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        this.screenCenterY = this.cameras.main.worldView.y + 15;

    }

    createDialogFullMask() {
        this.showingInstruction = true;
        objNames[characterSelected].active = false;
        objNames[characterSelected].setVelocity(0, 0);
        objNames[characterSelected].setFrame(4);
        objNames[characterSelected].anims.play(`repose-${characterSelected}-game8`);
        this.startAll = false;
        // this.dialogModal._createWindow(this, 'message-fullMask', null, true);
        this.dialogModal._createImageDialog(this, 'message-fullMask');
        
        this.dialogModal.setText("At last, I have all the fragments. \nNow, I suppose I need to figure out how to assemble them".toUpperCase(), `${characterSelected}-hallway`, false, false)
    }

    updateRoomOverlapZoom(callback) {
        // clearTimeout(this.timeoutRoom1);
        // this.timeoutRoom1 = setTimeout(() => {
        this.cameras.main.fade(100, 0, 0, 0, false, (cam, progress) => {
            if (progress === 1) {
                this.hasZoom = false;
                // this.physics.world.removeCollider(this.colliderSection);

                walls.setScale(3);
                this.map.ground.setScale(3);
                this.object.setScale(3);
                this.room1.setScale(3);
                this.room2.setScale(3);
                this.room3.setScale(3);
                this.room4.setScale(3);
                this.redRoom.setScale(3);
                this.room1Limit.setScale(3);
                this.room2Limit.setScale(3);
                this.room3Limit.setScale(3);
                this.room4Limit.setScale(3);
                this.deadSprite.setScale(3);
                this.door.setScale(3);
                this.exit.setScale(3);
                objNames[characterSelected].setScale(2);
                this.enemy.setScale(2);
                objNames[characterSelected].y = objNames[characterSelected].y * 3;
                objNames[characterSelected].x = objNames[characterSelected].x * 3;
                // objNames[characterSelected].active = true;
                // this.enemy.y = this.enemy.y * 3;
                // this.enemy.x = this.enemy.x * 3;
                this.cameras.main.setBounds(0, 0, 11256);
                this.physics.world.setBounds(0, 0, 11256);
                callback()
                this.cameras.main.fadeIn();
                // this.cameras.main.startFollow(objNames[characterSelected], true);
            }
        });
        // }, 500);
    }

    updateRoomOverlapNoZoom(callback) {
        this.cameras.main.fade(100, 0, 0, 0, false, (cam, progress) => {
            if (progress === 1) {
                this.cameras.main.fadeIn();
                this.hasZoom = true;
                this.cameras.main.setBounds(0, 0, 3752);
                this.physics.world.setBounds(0, 0, 3752);
                walls.setScale(1);
                this.map.ground.setScale(1);
                this.object.setScale(1);
                this.room1.setScale(1);
                this.redRoom.setScale(1);
                this.room2.setScale(1);
                this.room3.setScale(1);
                this.room4.setScale(1);
                objNames[characterSelected].clearTint();
                this.room1Limit.setScale(1);
                this.room2Limit.setScale(1);
                this.room3Limit.setScale(1);
                this.room4Limit.setScale(1);
                this.deadSprite.setScale(1);
                this.door.setScale(1);
                this.exit.setScale(1);
                // this.cameras.main.stopFollow();
                objNames[characterSelected].setScale(1);
                this.enemy.setScale(1);
                objNames[characterSelected].y = objNames[characterSelected].y / 3;
                objNames[characterSelected].x = objNames[characterSelected].x / 3;
                callback()
                // this.enemy.y = this.enemy.y / 3;
                // this.enemy.x = this.enemy.x / 3;
            }
        });
    }


    update() {

        this.textMask.setText(`${this.piecesMask} / 4`);
        if (this.startAll) {

            const speed = 300;

            if (objNames[characterSelected].active) {
                if (this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                } else {
                    walkHandler(cursors, objNames[characterSelected], speed, `${characterSelected}-game8`, hasLightstick);
                }
            }

            if (this.enemy.active) {
                directionHandler(this.enemy, 100, `enemy-game8`);
                switch (this.randomRoom) {
                    case 0:
                        this.hp.updatePosition(this.enemy.x - 290, this.enemy.y - 235);
                        break;
                    case 2:
                        this.hp.updatePosition(this.enemy.x - 1302, this.enemy.y - 1980);
                        break;
                    case 1:
                        this.hp.updatePosition(this.enemy.x - 690, this.enemy.y - 100);
                        break;
                    case 3:
                        this.hp.updatePosition(this.enemy.x - 2470, this.enemy.y - 420);

                        break;
                }
            }

            if (this.deadSprite.visible) {
                this.deadSprite.setPosition(this.enemy.x, this.enemy.y);
            }

            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }

        } else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game8`);
                    this.joystickManager.pause();
                }
            }
        }



    }

}